import { IntegrityMonitorPolicyRuleSetsSectionGzDataProvider } from '../dataProvider/IntegrityMonitorPolicyRuleSetsSectionGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../../../webcomponents.constants';

export class IntegrityMonitorPolicyRuleSetsSectionDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, IntegrityMonitorPolicyRuleSetsSectionGzDataProvider);
  }
}
